"use client";

import { usePathname } from "next/navigation";

import { SiteHeader } from "./site-header";

/**
 * F34 — the global <SiteHeader> is rendered once in app/layout.tsx for every
 * route, but the quiz owns its own chrome (logo + Save & exit + progress bar)
 * inside quiz-player.tsx, and the result page renders its own <ResultHeader>
 * (sparrow + MoneyImprint + Your result pill) from sprint5/result-chrome. On
 * /quiz and /result/* both routes produced two stacked headers; this wrapper
 * suppresses the global one on those routes so the page-owned chrome stands
 * alone. Every other route renders the normal site header.
 */
export function ConditionalSiteHeader() {
  const pathname = usePathname();
  if (pathname?.startsWith("/quiz")) return null;
  if (pathname?.startsWith("/result")) return null;
  return <SiteHeader />;
}
